export default "__VITE_ASSET__2Iu3efA5__"